module.exports = __webpack_public_path__ + "img/st1.5ad4003c.png";